@if (submitInfo(); as submitInfo) {
  @if (submitInfo.textSubmitProposal) {
    <div class="ion-padding-bottom screen-text-with-newlines">{{ submitInfo.textSubmitProposal }}</div>
  }
  @if (dataList(); as dataList) {
    <pa-generic-data-table [list]="dataList" />
  }
  @if (messages().length) {
    <hr class="warning-divider" />
    <div>
      @for (message of messages(); track message.message) {
        <div class="warning">
          <pa-status-message [melding]="message" />
        </div>
      }
    </div>
  }
}
